module.exports = __webpack_public_path__ + "static/media/content-library.ed7f8b37.svg";